"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TonPriceManager = void 0;
const ton_core_1 = require("ton-core");
const create_payload_cell_1 = require("../src/create-payload-cell");
const ton_utils_1 = require("../src/ton-utils");
const redstone_constants_1 = require("redstone-protocol/src/common/redstone-constants");
const TonContract_1 = require("../src/TonContract");
const operations_1 = require("../src/config/operations");
class TonPriceManager extends TonContract_1.TonContract {
    static getName() {
        return "price_manager";
    }
    async sendWritePrices(provider, paramsProvider) {
        const builder = (0, ton_utils_1.messageBuilder)(operations_1.OP_REDSTONE_WRITE_PRICES);
        const payloadCell = (0, create_payload_cell_1.createPayloadCell)(await paramsProvider.getPayloadHex(false));
        const dataFeedsIdsCell = (0, ton_core_1.serializeTuple)((0, ton_utils_1.createTupleItems)(paramsProvider.getHexlifiedFeedIds()));
        builder.storeRef(dataFeedsIdsCell);
        builder.storeRef(payloadCell);
        const body = builder.endCell();
        return await this.internalMessage(provider, paramsProvider.requestParams.dataFeeds.length *
            paramsProvider.requestParams.uniqueSignersCount *
            0.05, body);
    }
    async getReadPrices(provider, paramsProvider) {
        const { stack } = await provider.get("read_prices", [
            {
                type: "tuple",
                items: (0, ton_utils_1.createTupleItems)(paramsProvider.getHexlifiedFeedIds()),
            },
        ]);
        return (0, ton_utils_1.createArrayFromTuple)(stack.readTuple());
    }
    async getReadTimestamp(provider) {
        const { stack } = await provider.get("read_timestamp", []);
        return stack.readNumber();
    }
    async getPrices(provider, paramsProvider) {
        const payloadCell = (0, create_payload_cell_1.createPayloadCell)(await paramsProvider.getPayloadHex(false));
        const dataFeedIds = (0, ton_utils_1.createTupleItems)(paramsProvider.getHexlifiedFeedIds());
        // the v4 api is using only GET methods with limited parameter length, so it works only when the payload is small;
        // also don't support ECRECOVER
        const shouldUseOldApi = true; // !!this.oldApi;
        return shouldUseOldApi
            ? await this.getPricesV2(provider, dataFeedIds, payloadCell)
            : await this.getPricesV4(provider, dataFeedIds, payloadCell);
    }
    async getPricesV2(provider, dataFeedIds, payloadCell) {
        const getProvider = this.oldApi?.provider(this.address, null) ?? provider;
        const { stack } = await getProvider.get("get_prices_v2", [
            {
                type: "cell",
                cell: (0, ton_core_1.serializeTuple)(dataFeedIds),
            },
            { type: "cell", cell: payloadCell },
        ]);
        return (0, ton_utils_1.createArrayFromSerializedTuple)(stack.readCell(), redstone_constants_1.DEFAULT_NUM_VALUE_BS * 8);
    }
    async getPricesV4(provider, dataFeedIds, payloadCell) {
        const { stack } = await provider.get("get_prices", [
            {
                type: "tuple",
                items: dataFeedIds,
            },
            { type: "cell", cell: payloadCell },
        ]);
        return (0, ton_utils_1.createArrayFromTuple)(stack.readTuple());
    }
}
exports.TonPriceManager = TonPriceManager;
//# sourceMappingURL=TonPriceManager.js.map